// Los productos de ejemplo del rubro, en "Añadir producto" de las primeras piezas, para quien
// no tiene una foto a mano (ADR-2026-10-23-productos-de-ejemplo-en-las-primeras-piezas). Son los
// mismos del cuestionario de siempre (`getExampleProducts`): dos por rubro, el set por defecto
// para los que no tienen propio. Elegir uno lo carga como si fuera la foto subida — la pantalla
// se encarga —, así que se genera de verdad, con la marca.

import CachedImg from '../../CachedImg';
import { categoriaDelRubro, getExampleProducts, type ExampleProduct } from '../accountSetup';

export function ProductosDeEjemplo({
  rubro,
  elegidoId,
  cargandoId,
  onElegir,
}: {
  rubro: string;
  /** El ejemplo que está cargado como foto, si lo hay. */
  elegidoId: string | null;
  /** El que se está bajando para usarlo (la foto tarda un instante). */
  cargandoId: string | null;
  onElegir: (ejemplo: ExampleProduct) => void;
}) {
  const ejemplos = getExampleProducts([categoriaDelRubro(rubro)]);
  return (
    <div className="om-ejemplos-prod">
      <p className="om-ejemplos-prod__titulo" id="om-ejemplos-prod">
        ¿No tienes una foto a mano? Prueba con uno de los nuestros
      </p>
      <div className="om-ejemplos-prod__lista" role="group" aria-labelledby="om-ejemplos-prod">
        {ejemplos.map((ej) => {
          const elegido = elegidoId === ej.id;
          return (
            <button
              key={ej.id}
              type="button"
              onClick={() => onElegir(ej)}
              disabled={cargandoId !== null}
              aria-pressed={elegido}
              className={`om-ejemplo-prod ${elegido ? 'is-elegido' : ''}`}
            >
              <span className="om-ejemplo-prod__foto">
                <CachedImg src={ej.image} alt="" draggable={false} />
                {elegido && (
                  <span className="om-ejemplo-prod__tilde material-symbols-rounded" aria-hidden="true">
                    check
                  </span>
                )}
              </span>
              <span className="om-ejemplo-prod__nombre">{cargandoId === ej.id ? 'Cargando…' : ej.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProductosDeEjemplo;
